import React from 'react';

interface LinkWithArrowProps {
  href: string;
  text: string;
}

const LinkWithArrow: React.FC<LinkWithArrowProps> = ({ href, text }) => {
  return (
    <a
      href={href}
      className="flex items-center text-black-600 hover:text-blue-800"
    >
      {text}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="2"
        stroke="currentColor"
        className="w-5 h-5 ml-5 mt-1"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
        />
      </svg>
    </a>
  );
};

export default LinkWithArrow;